import React from 'react';
import { Button, Modal } from 'antd';
import ImportJobProgress from './index';
import { ImportInProgress, ImportJobView } from '../../services/importJobApi';

interface Props {
    /** The 409 IMPORT_IN_PROGRESS a Place / Start got; null hides the modal. */
    conflict: ImportInProgress | null;
    onClose: () => void;
    onReady?: (job: ImportJobView) => void;
}

/** Grid Place / pair Start refused because an import on the account is open: show where it is. */
const ImportInProgressModal: React.FC<Props> = ({ conflict, onClose, onReady }) => (
    <Modal
        open={conflict != null}
        onCancel={onClose}
        title="An import is not finished"
        footer={<Button onClick={onClose}>Close</Button>}
        destroyOnClose
    >
        {conflict && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 12 }}>
                <span>{conflict.message}</span>
                <ImportJobProgress importId={conflict.importId} onReady={onReady} />
            </div>
        )}
    </Modal>
);

export default ImportInProgressModal;
